/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import { showModal } from "actions";
import TrainingDetailModal from "components/widgets/training/TrainingDetailModal";
import { connect } from "react-redux";
import { Trans } from "react-i18next";

class RoleTraining extends Component {
  rowClassName = "";

  state = {
    showingChildren: true,
  };

  toggleChildren = () => {
    let showingChildren = this.state.showingChildren;
    this.setState({ showingChildren: !showingChildren });
  };

  showDetail = (t) => {
    //ELearning ise açılmasın
    if (t.trainingMethod.value === 1) return;

    this.props.showModal({
      modalType: "trainingDetail",
      modalTitle: "",
      modalContent: (
        <TrainingDetailModal
          training={t}
          trainingType="toBeCompleted"
          isParent={false} // Paket eğitim olmayacağı için default false gönderiliyor
        />
      ),
      modalFooter: null,
      modalCustomClassName: "modal-xl ttModal",
    });
  };

  renderDate = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleDateString(localStorage.getItem("i18nextLng"));
  };

  renderTime = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleTimeString(localStorage.getItem("i18nextLng"));
  };

  renderDateTime = (type, dateString) => {
    //1 = ELearning
    if (type !== 1)
      return (
        <>
          {this.renderDate(dateString)}
          <br />
          {this.renderTime(dateString)}
        </>
      );
    else return this.renderDate(dateString);
  };

  renderTrainingMethodIcon = (value) => {
    switch (value) {
      case 1:
        return (
          <td onClick={() => this.toggleChildren()}>
            <span className="iconmford fo-icon-live-tv "></span>
          </td>
        );
      case 3:
        return (
          <td onClick={() => this.toggleChildren()} className="showGrup">
            <span className="iconmford fo-icon-tv">
              <span className="path1"></span>
              <span className="path2"></span>
              <span className="path3"></span>
              <span className="path4"></span>
            </span>
          </td>
        );
      default:
        return (
          <td onClick={() => this.toggleChildren()}>
            <span className="iconmford fo-icon-class"></span>
          </td>
        );
    }
  };

  renderQuota(t) {
    //1 = ELearning
    if (t.trainingMethod.value === 1)
      return <Trans desc="Limitsiz">10512</Trans>;
    else {
      if (t.timeplans !== null && t.timeplans.length > 0)
        return `${t.timeplans[0].availableQuota}/${t.timeplans[0].quota}`;
      else return null;
    }
  }

  renderTabletModeDetail = (t) => {
    if (!this.state.showingChildren) {
      return (
        <tr className="child">
          <td className="child" colspan="2">
            <table>
              <tbody>
                <tr data-dt-row="0" data-dt-column="2">
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Yer">10016</Trans>
                    </div>
                  </td>
                  <td>{t.trainingLocation ?? ""}</td>
                </tr>
                <tr data-dt-row="0" data-dt-column="5">
                  <td>
                    <div className="tableTitle">Kontenjan</div>
                  </td>
                  <td>{this.renderQuota(t)}</td>
                </tr>
                <tr data-dt-row="0" data-dt-column="3">
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Süre">10017</Trans>
                    </div>
                  </td>
                  <td>
                    {t.timeplans !== null && t.timeplans.length > 0
                      ? `${t.timeplans[0].duration}`
                      : null}
                    <sup>
                      <Trans desc="GÜN">10388</Trans>
                    </sup>
                  </td>
                </tr>
                <tr data-dt-row="0" data-dt-column="6">
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Başlangıç">10020</Trans>
                    </div>
                  </td>
                  <td>
                    {t.timeplans !== null && t.timeplans.length > 0
                      ? this.renderDateTime(
                        t.trainingMethod.value,
                        t.timeplans[0].startDate
                      )
                      : null}
                  </td>
                </tr>
                <tr data-dt-row="0" data-dt-column="7">
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Bitiş">10021</Trans>
                    </div>
                  </td>
                  <td>
                    {t.timeplans !== null && t.timeplans.length > 0
                      ? this.renderDateTime(
                        t.trainingMethod.value,
                        t.timeplans[0].endDate
                      )
                      : null}
                  </td>
                </tr>
                <tr data-dt-row="9" data-dt-column="7">
                  <td>
                    <div className="tableTitle">Talep</div>
                  </td>
                  <td>
                    <a
                      href="#"
                      className="talepEtBtn"
                      onClick={() => this.showDetail(t)}
                    >
                      <Trans desc="Talep Et">10377</Trans>{" "}
                      <span className="icon-icon-table-request"></span>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      );
    } else return null;
  };

  render() {
    const { t } = this.props;
    return (
      <>
        <DesktopBreakpoint>
          <tr className="grupEgitim" key={t.id}>
            {this.renderTrainingMethodIcon(t.trainingMethod.value)}
            <td className="showGrup" onClick={() => this.showDetail(t)}>
              {t.training.name}
            </td>

            <td className="showGrup">{t.trainingLocation ?? ""}</td>
            <td className="showGrup">{this.renderQuota(t)}</td>
            <td className="showGrup">
              {t.timeplans !== null && t.timeplans.length > 0
                ? `${t.timeplans[0].duration}`
                : null}
              <sup>
                <Trans desc="GÜN">10388</Trans>
              </sup>
            </td>
            <td className="showGrup">
              {t.timeplans !== null && t.timeplans.length > 0
                ? this.renderDateTime(
                  t.trainingMethod.value,
                  t.timeplans[0].startDate
                )
                : null}
            </td>
            <td className="showGrup">
              {t.timeplans !== null && t.timeplans.length > 0
                ? this.renderDateTime(
                  t.trainingMethod.value,
                  t.timeplans[0].endDate
                )
                : null}
            </td>
            <td>
              <a
                href="#"
                className="talepEtBtn"
                onClick={() => this.showDetail(t)}
              >
                <Trans desc="Talep Et">10377</Trans>{" "}
                <span className="icon-icon-table-request"></span>
              </a>
            </td>

            <td></td>
          </tr>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <tr key={t.training.id} className={this.rowClassName}>
            {this.renderTrainingMethodIcon(t.trainingMethod.value)}
            <td onClick={() => this.showDetail(t)} className="showGrup">
              {t.training.name}
            </td>
          </tr>

          {this.renderTabletModeDetail(t)}
        </TabletBreakpoint>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
  };
};

export default connect(mapStateToProps, { showModal })(RoleTraining);
